import { Statuses } from 'interfaces/ITask.interface';
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { CQAppConstant } from 'app-constants';


export interface ISubTaskProps {
    subtask: { name: string, status: number };
}

export function CQSubTask(prop : ISubTaskProps) {
    const {t, i18n} = useTranslation();
    const [status, setStatus] = useState<string>(CQAppConstant.TASK_STATUS_LABELS.PENDING);

    /**
    * Returns the translated name of the first subtask property.
    */
    function getName() {
        const defaultKey = prop.subtask.name;
        const taskKey = `task_${defaultKey}`;
        return i18n.exists(taskKey) ? t(taskKey) : (i18n.exists(defaultKey) ? t(defaultKey) : defaultKey);
    }

    useEffect(() => {
            let status = prop.subtask.status;
            switch (status) {
                case Statuses.Completed: setStatus(CQAppConstant.TASK_STATUS_LABELS.COMPLETED); break;
                case Statuses.Pending: setStatus(CQAppConstant.TASK_STATUS_LABELS.PENDING); break;
                case Statuses.Failed: setStatus(CQAppConstant.TASK_STATUS_LABELS.FAILED); break;
                default: setStatus(CQAppConstant.TASK_STATUS_LABELS.NOT_STARTED); break;
            }
        },[prop.subtask, prop.subtask.status])

    return <>
        <tr className="slds-hint-parent">
            <th data-label={t("task_subtask_name_column")} scope="row">{getName()}</th>
            <td data-label={t("task_subtask_status_column")}>
                <span className={`slds-badge ${status === CQAppConstant.TASK_STATUS_LABELS.COMPLETED ? 'slds-theme_success' : status === CQAppConstant.TASK_STATUS_LABELS.FAILED ? 'slds-theme_error' : status === CQAppConstant.TASK_STATUS_LABELS.PENDING ? 'slds-theme_warning' : ''}`}>
                    {status}
                </span>
            </td>
        </tr>
    </>
}